import React from 'react';
import { PageLayout } from '../../components/page-layout';
import { OnboardingProgressBar } from '../../components/onboarding-progress-bar';
import { useOnboarding } from '../../providers/onboarding-provider';
import { OnboardingForm } from '../../components/onboarding/OnboardingForm';

const UPDATES_DISCLAIMER =
  'Your medical decisions are always entirely up to you and your healthcare provider.';

export const UpdatesPage = () => {
  const { completeStep } = useOnboarding();

  return (
    <PageLayout>
      <div className="content-layout">
        <OnboardingProgressBar />
        <OnboardingForm
          stepKey="UPDATES"
          className="preferences-form updates-form"
          submitLabel="Submit"
          allowSkip
          disclaimer={UPDATES_DISCLAIMER}
          onComplete={() => completeStep('UPDATES')}
        />
      </div>
    </PageLayout>
  );
};
